<template>
    <div class="wrap">
        <div class="hd">
            <div class="top">
                <img src="../../static/img/tuichu.png" alt="" @click="logOut">
                <vant-select v-if="isMultiLeagues"
                        :list="joinedLeagues"
                        default="切换组织"
                        optionName="leagueName"
                        type="objectArr"
                        showTitle='no'
                        :defaultValue="defaultValue"
                        @chooseFn="chooseIdentityFn"
                >
                </vant-select>
            </div>
            <div class="bottom">
                <div class="hd_left">
                    <div>
                        <img v-if="curLeague.leaguePhotoUrl != '' " :src="curLeague.leaguePhotoUrl" alt="">
                        <img v-else src="../../static/img/logo.png" alt="">
                    </div>
                    <div style="max-width: 80%">
                        <p>{{curLeague.leagueName}}{{cardInfo}}</p>
                        <p>{{user.userName}}</p>
                    </div>
                </div>
                <div class="hd_right">

                    <img v-if="curLeague.isLeagueAdmin === 1 || (curLeague.isObserver == 1 && curLeague.roleId == 5)"
                         src="../../static/img/usercenter.png" alt="" @click="jump('mine')">

                </div>

            </div>
        </div>
        <div class="bd">

            <div class="explain">
                <div>
                    <van-icon name="warning-o" color="#e32322" size="20"/>
                </div>
                <div>
                    <p>1、关于常规业务流程、操作方法等问题，可查看PC端"常见问题"或直接咨询上级团组织管理员；</p>
                    <p>2、如有其他技术问题，可将问题详情和系统截图发送至邮箱：zhtjwtfk@163.com。</p>
                </div>
            </div>
        </div>
        <div class="ft">
            <!-- 团的领导机关-->
            <van-grid :column-num="3" v-if="curLeague.leagueTypeId=='05TDLDJG'">
<!--                <van-grid-item to="graduateMember">-->
<!--                    <img src="../../static/img/icon9.png" alt="">-->
<!--                    <a>毕业团员<br/>去向统计</a>-->
<!--                </van-grid-item>-->
<!--                <van-grid-item to="transferProcessMonitor">-->
<!--                    <img src="../../static/img/icon8.png" alt="">-->
<!--                    <p>组织关系转接<br>业务监测指标</p>-->
<!--                </van-grid-item>-->
<!--                <van-grid-item to="higherGraduate">-->
<!--                    <img src="../../static/img/icon7.png" alt="">-->
<!--                    <p>升学类型毕<br>业去向统计</p>-->
<!--                </van-grid-item>-->

                <van-grid-item to="cadresIdentyChange" v-if="curLeague.isObserver != 1">
                    <img src="../../static/img/icon2.png" alt="">
                    <p>团干部职务变更</p>
                </van-grid-item>
                <van-grid-item to="adminChange" v-if="curLeague.isObserver != 1">
                    <img src="../../static/img/icon1.png" alt="">
                    <p>管理员变更</p>
                </van-grid-item>
            </van-grid>

            <!-- 团委-->
            <van-grid :column-num="3"
                      v-if="curLeague.leagueTypeId=='02TZZ'||curLeague.leagueTypeId=='03TW'||curLeague.leagueTypeId=='04TGW'">

                <van-grid-item to="cadresIdentyChange" v-if="curLeague.isObserver != 1">
                    <img src="../../static/img/icon2.png" alt="">
                    <p>职务变更</p>
                </van-grid-item>
                <van-grid-item to="adminChange" v-if="curLeague.isObserver != 1">
                    <img src="../../static/img/icon1.png" alt="">
                    <p>管理员变更</p>
                </van-grid-item>
            </van-grid>

            <!-- 团支部-->
            <van-grid :column-num="3"
                      v-else-if="curLeague.leagueTypeId=='01TZB'||curLeague.leagueTypeId=='00DJZTZB'||curLeague.leagueTypeId=='06BYBTZB'">
                <van-grid-item to="registerExamine">
                    <img src="../../static/img/icon3.png" alt="">
                    <p>注册审批</p>
                </van-grid-item>

                <van-grid-item to="cadresIdentyChange">
                    <img src="../../static/img/icon2.png" alt="">
                    <p>职务变更</p>
                </van-grid-item>
                <van-grid-item to="adminChange">
                    <img src="../../static/img/icon1.png" alt="">
                    <p>管理员变更</p>
                </van-grid-item>
            </van-grid>
        </div>

    </div>

</template>

<script>
    import {mapState} from 'vuex'
    import vantSelect from '../components/vantSelect'
    import cons from "@/cons";

    export default {
        name: "home",
        components: {vantSelect},
        data() {
            return {
                leagueOption: {
                    "02TZZ": "团总支",
                    "03TW": "团委",
                    "04TGW": "团工委",
                    "05TDLDJG": "团的领导机关",
                    "06BYBTZB": "毕业生团组织",
                    "00DJZTZB": "待接转团支部",
                    "01TZB": "团支部"
                },
                joinedLeagues: [],
                selectedLeague: {},
                defaultValue:'',
                profileData: {
                    leagueTypeId: '',
                    leagueTypeName: '',
                    leagueName: '',
                    leagueFullName: '',
                    industryTypeId: '',
                    graduationDate:"",
                    leagueSecretary: '',
                    contacTelephone: '',
                    contacEmail: '',
                    youth1428Num: '',
                    recommendPartyNum: '',
                    retainLeaguePartyNum: '',
                    parentLeagueName: '',
                    modifyName: '',
                    modifyTime: '',
                    admNum: '',
                    realAdmNum: '',
                    enterPriseNum: '',
                    realEnterPriseNum: '',
                    photoFileId: '',
                    identityCardNo: "",
                    mobile: "",
                    type: 1,
                },
            }
        },
        created() {
            this.selectedLeague = this.curLeague.leagueId

            if(this.isMultiLeagues) {
                this.joinedLeagues =  this.loginedInfo['joinedLeagues']
            }

            let index =  this.joinedLeagues.findIndex((item,i)=>{
                return item.leagueId === this.curLeague.leagueId
            })
            this.defaultValue = index + 1

            // if this is admin
            if(this.curLeague.isLeagueAdmin === 1) {
                this.getLeagueInfo()
            }

            console.log(this.curLeague)

        },
        computed: {
            ...mapState({
                user: state => state.user,
                curLeague: state => state.league,
                commonparams: state => state.commonparams,
                loginedInfo: state => state.loginedInfo,
            }),
            cardInfo() {
                if (this.curLeague.isLeagueAdmin == 1) {
                    return "(管理员)"
                } else if (this.curLeague.isObserver == 1) {
                    return "(观察员)"
                }
                return ""
            },
            isMultiLeagues() {
                if ('joinedLeagues' in this.loginedInfo && this.loginedInfo['joinedLeagues'].length > 1) {
                    return true
                }
                return false
            },

        },
        methods:{
            getLeagueInfo() {

                if (this.curLeague.isLeagueAdmin == 1) {
                    console.log("tip")
                    console.log(this.curLeague)
                    let param = new FormData()
                    param.append('queryLeagueId', this.curLeague.leagueId)
                    param.append('parentLeagueId', this.curLeague.parentLeagueId)
                    let self = this
                    this.PF('/viewleagueinfo', param, {baseURL: cons.u})
                        .then((response) => {
                            if (response.status == 200) {
                                if (response.data.retCode === 1000) {
                                    self.profileData = {...self.profileData, ...response.data.results}

                                    if(self.profileData.leagueTypeId=='01TZB'
                                        && self.checkIsSchoolNotContainXX(self.profileData.industryTypeId)
                                        && !self.profileData.notClassReason
                                        && !self.profileData.graduationDate){

                                        this.$toast({
                                            message: "请尽快登录网页版“智慧团建”系统标记团支部团员毕业时间",
                                            duration: 3000,
                                        })
                                    }

                                } else {
                                    let msg = response.data.retMsg
                                    self.$toast.fail({
                                        message: msg,
                                    })
                                }
                            } else {
                                console.log("Got Return code:" + response.status)
                                self.$toast.fail({
                                    message: '网络异常，请稍后再试'
                                })
                            }
                        })
                }
            },
            checkIsSchoolNotContainXX(industryTypeId) {
                if ("03PTGDYX" == industryTypeId
                    || "04ZYJYXX" == industryTypeId
                    || "05PTGZ" == industryTypeId
                    || "051ZDZYYX" == industryTypeId
                    || "052WQZX" == industryTypeId
                    || "06CZ" == industryTypeId
                    || "071JNYGZXX" == industryTypeId
                    || "072SENYGZXX" == industryTypeId) {
                    return true;
                }

                return false;
            },
            updateLocal(user, league) {
                this.$store.commit('SET_USER', {user})
                this.$store.commit('SET_LEAGUE', {league})
            },
            chooseIdentityFn(theLeague){
                console.log(theLeague)

                // 修改当前组织
                let switchLeague = {}
                let found = false
                let leagues = this.loginedInfo['joinedLeagues']
                for (let i in leagues) {
                    if (leagues[i].leagueId == theLeague.leagueId) {
                        switchLeague = leagues[i]
                        found = true
                        break
                    }
                }
                if (found == false) {
                    this.$dialog.alert({
                        message: "未找到选择的团组织",
                        theme: 'round-button',
                    }).then(() => {
                        // on close
                    });
                    // this.$notify({
                    //     type: 'danger',
                    //     message: '未找到选择的团组织',
                    // })
                    return
                }

                let self = this
                let param = new FormData()
                param.append('switchLeagueId', theLeague.leagueId)
                param.append('userId', self.user.userId)
                this.loading = true
                this.$root.PF('/validSwitchLeague', param, {})
                    .then(function (response) {
                        self.loading = false

                        if (response.status == 200) {

                            if (response.data.retCode === 1000) {
                                let isadmin = switchLeague.isLeagueAdmin == 1 ? true : false
                                let isObserver = switchLeague.isObserver == 1 ? true : false
                                let isDefalutLeague = switchLeague.isDefaultLeague == 1 ? true : false
                                let isBelong = switchLeague.isBelong == 1 ? true : false
                                //用于控制发起组织迁移的弹框页面
                                if ('orgmove' in self.commonparams) {
                                    delete self.commonparams['orgmove']
                                }
                                if (isadmin) {
                                    self.$store.commit('SET_TIPS', {
                                        'showCheckLeader': 1,
                                        'showUserCode': 1,
                                        'showLeaderImport': 1,
                                        "showImport": 1,
                                        "showImportTZB": 1,
                                        "showCheckFullIn": 1,
                                    })
                                }
                                let u = self.user
                                window && window.localStorage.clear()
                                self.updateLocal(u, switchLeague)
                                var viewType, router
                                if (!isObserver && !isadmin) {
                                    viewType = 'mine'
                                    router = '/mine/'
                                    self.$emit('viewTypechange', viewType)
                                    //因有切换组织时路由不变的情况（如从 个人中心跳到别的组织的个人中心），所以先判断新路由 和老路由是否有差异。若无差异直接刷新页面
                                    console.log(self.$route.fullPath)
                                    if (router == self.$route.fullPath) {
                                        // self.go(0)
                                        window.location.reload()
                                    } else {
                                        self.jump(router)
                                    }
                                    self.qm()
                                }

                            } else {
                                // let msg = response.data.retMsg
                                // this.$notify({
                                //     type: 'danger',
                                //     message: msg,
                                // })
                                self.$dialog.alert({
                                    message: response.data.retMsg,
                                    theme: 'round-button',
                                }).then(() => {
                                    // on close
                                });
                            }
                        } else {
                            console.log("Got Return code:" + response.status)
                            self.$dialog.alert({
                                message: "网络异常，请稍后再试",
                                theme: 'round-button',
                            }).then(() => {
                                // on close
                            });
                            // this.$notify({
                            //     type: 'danger',
                            //     message: '网络异常，请稍后再试'
                            // })
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {

                        } else if (error.request) {
                            console.log(error.request);

                        } else {
                            // Something happened in setting up the request that triggered an Error
                            console.log('Error', error.message);
                        }
                        console.log(error.config);
                    });
            },
            qm() {
                // 查消息相关 暂时不用
            },
            logOut() {
                console.log("logOut")
                let self = this
                let param = new FormData()
                param.append('currLeagueId', this.curLeague.leagueId)
                param.append('currUserId', this.user.userId)

                this.loading = true
                this.$root.PF('/signout', param, {})
                    .then(function (response) {
                        console.log(response)
                        self.loading = false

                        if (response.status == 200) {
                            self.$store.commit('CLEAR')
                            self.$store.commit('CLEAR_PARAMS')
                            window && window.localStorage.clear()
                            self.jump('/')
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {

                        } else if (error.request) {
                            console.log(error.request);

                        } else {
                            // Something happened in setting up the request that triggered an Error
                            console.log('Error', error.message);
                        }
                        console.log(error.config);
                    });
            },
        },

    }

</script>

<style scoped>
    .wrap {
        background-color: #eeedf0;
        height: 100%;
        width: 100%;
    }

    .hd {
        width: 100%;
        height: 200px;
        background: url("../../public/img/img-top.png") no-repeat 0 0;
        background-size: 100% 100%;
        /*display: flex;*/
        /*flex-direction: column;*/
    }
    .hd .top{
        display: flex;
        justify-content: space-between;
        /*float: right;*/
        padding: 20px 30px 0;
        align-items: center;
    }
    .hd .top img{
        width: 25px;
        color: white;
    }
    .hd .bottom{
        width: 100%;
        display: flex;
        padding-top: 20px;
        align-items: center;
        justify-content: space-between;
    }

    .hd .hd_left {
        display: flex;
        padding-left: 30px;
        align-items: flex-start;
    }

    .hd .hd_left img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        /*border: 2px solid white;*/
        /*background-color: white;*/
    }

    .hd .hd_left p {
        color: white;
        font-size: 16px;
        margin: 5px 10px;

    }

    .hd .hd_right {
        padding-right: 20px;
    }
    .hd .hd_right img{
        height: 30px;
        width: auto;
    }

    .bd .explain {
        width: 90%;
        border-radius: 5px;
        background-color: white;
        margin: 10px auto;
        display: flex;
        padding: 10px;

    }

    .bd .explain p {
        margin: 0 0 0 10px;
        color: #656565;
        font-size: 15px;
    }

    .ft {
        width: 95%;
        margin: 0 auto;
        /*background-color: white;*/
    }

    .ft img {
        width: auto;
        height: 40px;
    }

    .ft p {
        font-size: 14px;
        color: #656565;
        text-align: center;
    }

    /deep/ .ft .van-grid-item__content {
        padding: 10px 8px;
    }
    /deep/ .van-dropdown-menu__bar{
        height: 100%;
        box-shadow: none;
        background-color: transparent;
    }
    /deep/ .van-ellipsis{
        color: white;
    }
    /deep/ .van-dropdown-menu__title::after{
        border-color: transparent transparent white white;
    }


</style>
